import { apiDelete, apiGet, apiPost } from '../../../utils';

export function getAllAdminsAPI(filters) {
  let arr = []
  for (const [key, value] of Object.entries(filters)) {
    if (key === "isOpen") continue
    if (typeof value !== "number" && !value?.length) continue

    arr.push({ key, value: encodeURIComponent(value), type: "single" })
  }

  return apiGet(`/api/admin?filter=${JSON.stringify(arr)}`)
}

export function getAdminAPI(id) {
  return apiGet(`/api/admin/${id}`)
}

export function deleteAdminAPI(id) {
  return apiDelete(`/api/admin/${id}`)
}

export function createAdminAPI(data) {
  return apiPost('/api/admin', data)
}
